import React from "react";
import * as S from "./styles";

export const SearchCard = ({ course }) => {
  const suffix = (course?.classes && Number(course?.classes)) > 1 ? "s" : "";

  return (
    <S.Wrapper>
      <S.ImageContainer>
        <img src={`${course.images?.thumbUrl}`} alt={"thumb course"} />
      </S.ImageContainer>
      <S.InfoContainer>
        <p className="search-course-title">{course.title}</p>
        <p className="search-course-author">
          <strong>por {course.author?.name}</strong>
        </p>
        <div className="classes">
          <ClassesIcon />{" "}
          <span>
            {course.classes} aula{suffix}
          </span>
        </div>
      </S.InfoContainer>
    </S.Wrapper>
  );
};

const ClassesIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 3.75V21.25H17.7419V20H5V5H21.875V6.325H23.125V3.75H3.75ZM23.125 10C23.125 10.3315 22.9933 10.6495 22.7589 10.8839C22.5245 11.1183 22.2065 11.25 21.875 11.25C21.5435 11.25 21.2255 11.1183 20.9911 10.8839C20.7567 10.6495 20.625 10.3315 20.625 10C20.625 9.66848 20.7567 9.35054 20.9911 9.11612C21.2255 8.8817 21.5435 8.75 21.875 8.75C22.2065 8.75 22.5245 8.8817 22.7589 9.11612C22.9933 9.35054 23.125 9.66848 23.125 10ZM24.375 10C24.375 10.663 24.1116 11.2989 23.6428 11.7678C23.1739 12.2366 22.538 12.5 21.875 12.5C21.212 12.5 20.5761 12.2366 20.1072 11.7678C19.6384 11.2989 19.375 10.663 19.375 10C19.375 9.33696 19.6384 8.70107 20.1072 8.23223C20.5761 7.76339 21.212 7.5 21.875 7.5C22.538 7.5 23.1739 7.76339 23.6428 8.23223C24.1116 8.70107 24.375 9.33696 24.375 10Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8079 13.6438C19.1565 13.311 19.6198 13.1252 20.1017 13.125H22.6529C23.5679 13.125 24.4198 13.4362 25.076 14.0562C25.7073 14.6525 26.036 15.4169 26.1704 16.1413C26.3817 17.28 26.1629 18.5244 25.6248 19.6275V24.6875C25.6248 25.0796 25.4774 25.4574 25.2118 25.7458C24.9462 26.0343 24.5819 26.2124 24.1912 26.2447C23.8004 26.2771 23.4118 26.1613 23.1024 25.9204C22.793 25.6795 22.5855 25.3311 22.521 24.9444L22.1873 22.9419L21.8535 24.9444C21.7891 25.3311 21.5816 25.6795 21.2722 25.9204C20.9628 26.1613 20.5742 26.2771 20.1834 26.2447C19.7926 26.2124 19.4283 26.0343 19.1627 25.7458C18.8972 25.4574 18.7498 25.0796 18.7498 24.6875V20.94V18.8081C18.4648 18.9727 18.1414 19.0594 17.8123 19.0594H14.6235C14.1263 19.0594 13.6493 18.8618 13.2977 18.5102C12.9461 18.1586 12.7485 17.6817 12.7485 17.1844C12.7485 16.6871 12.9461 16.2102 13.2977 15.8586C13.6493 15.5069 14.1263 15.3094 14.6235 15.3094H17.061L18.8079 13.6431V13.6438ZM19.9998 20.9219V24.6875C20 24.7658 20.0296 24.8411 20.0827 24.8986C20.1358 24.9562 20.2086 24.9916 20.2866 24.9981C20.3646 25.0045 20.4422 24.9815 20.504 24.9334C20.5658 24.8854 20.6074 24.8159 20.6204 24.7388L21.2723 20.8288C21.2965 20.6828 21.3718 20.5502 21.4846 20.4545C21.5975 20.3589 21.7406 20.3063 21.8885 20.3063H22.486C22.634 20.3063 22.7771 20.3589 22.8899 20.4545C23.0028 20.5502 23.078 20.6828 23.1023 20.8288L23.7542 24.7388C23.7672 24.8159 23.8088 24.8854 23.8706 24.9334C23.9324 24.9815 24.01 25.0045 24.088 24.9981C24.166 24.9916 24.2388 24.9562 24.2919 24.8986C24.345 24.8411 24.3746 24.7658 24.3748 24.6875V19.4788C24.3748 19.3787 24.3988 19.2801 24.4448 19.1913C24.9273 18.26 25.1029 17.2394 24.9417 16.3694C24.8435 15.8406 24.6142 15.3394 24.2179 14.965C23.8135 14.5831 23.2773 14.375 22.6529 14.375H20.1023C19.9417 14.375 19.7867 14.4369 19.6704 14.5475L17.7429 16.3863C17.6268 16.4972 17.4723 16.5592 17.3117 16.5594H14.6235C14.4578 16.5594 14.2988 16.6252 14.1816 16.7424C14.0644 16.8596 13.9985 17.0186 13.9985 17.1844C13.9985 17.3501 14.0644 17.5091 14.1816 17.6263C14.2988 17.7435 14.4578 17.8094 14.6235 17.8094H17.8123C17.9729 17.8092 18.1274 17.7472 18.2435 17.6363L18.9435 16.9688C19.0321 16.8843 19.1435 16.8278 19.2639 16.806C19.3843 16.7843 19.5084 16.7985 19.6209 16.8466C19.7334 16.8948 19.8292 16.9749 19.8966 17.0771C19.9639 17.1792 19.9998 17.2989 19.9998 17.4213V20.9225V20.9219Z"
        fill="#fff"
      />
    </svg>
  );
};

export default SearchCard;
